module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/magazine/point05_04_sunset-43eec4bc7e29af34060b0e48b4e7c0f8.jpg";